import React from 'react'
import { Box, Text } from "grommet"

import Clock from 'react-live-clock'
import TimeAgo from 'react-timeago'

import { useMarketStateUpcoming, useMarketStateHoliday } from '../market/Api'
import TTTip, { TTTipMulti } from './TTTip'


const AppTopTicker = () => {

    const listTimezones = {
        'Chicago': 'America/Chicago',
        'Singapore': 'Asia/Singapore',
        'Pune': 'Asia/Calcutta',
        'UTC': 'UTC',
        'London': 'Europe/London',
    }

    const marketSchedules = useMarketStateUpcoming(Object.keys(listTimezones).length, window.innerWidth)
    const marketHolidays = useMarketStateHoliday(7)

    // Custom Timeago Formatter
    const PostedTime = ({ date }) => {
        return <TimeAgo date={date} formatter={formatter} />
    }

    function formatter(value, unit, suffix) {
        let output = suffix === 'from now' ? 'in ' + value + ' ' + unit + "s" : 'now'
        return output
    }

    return (
        <>
            <Box
                direction="row"
                fill="horizontal"
                justify="center"
                align="center"
                alignContent="center"
                alignSelf="center"
            >
                <Box
                    justify="center"
                    wrap={true}
                    fill="horizontal"
                    align="center"
                    alignContent="center"
                    alignSelf="center"
                    pad="xxsmall"
                    background="brand"
                    direction="row"
                    gap="15px"
                >
                    {Object.keys(listTimezones).map(timezone =>
                        <Box key={timezone} margin={{ top: "3px" }}>
                            <Text size="12px">
                                <Text weight="bold" size="13px">{timezone} </Text>
                                <Clock format={'HH:mm:ss ZZ'} ticking={true} timezone={listTimezones[timezone]} />
                            </Text>
                        </Box>
                    )}
                    {marketHolidays &&
                        <TTTipMulti hoverMessage={marketHolidays} position="bottom">
                            <Box
                                wrap={true}
                                direction="row"
                                gap="4px"
                                justify="end"
                                align="end"
                                alignContent="end"
                                alignSelf="end"
                            >
                                <Text weight="bold" size="13px">🎉 Holidays</Text>
                            </Box>
                        </TTTipMulti>
                    }
                    {marketSchedules && marketSchedules.map(market => {
                        const marketColour = (market.next_state === 'Closed' || market.next_state === 'disconnect') ? 'ttdownlight' : 'ttoklight'
                        return (
                            <TTTip hoverMessage={market.until} position="bottom" key={market.name}>
                                <Box
                                    wrap={true}
                                    direction="row"
                                    gap="4px"
                                    justify="end"
                                    align="end"
                                    alignContent="end"
                                    alignSelf="end"
                                >
                                    <Text weight="bold" size="13px">
                                        {market.name + " "}
                                    </Text>
                                    <Text size="12px" weight="bold" color={marketColour}>
                                        {market.next_state + " "}
                                    </Text>
                                    <Text size="12px" weight="normal">
                                        <PostedTime date={market.untilDateTimeMoment} />
                                    </Text>
                                </Box>
                            </TTTip>
                        )
                    }
                    )}
                </Box>
            </Box>
        </>
    )
}

export default AppTopTicker
